import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { RewardType } from '~/shared';
import {
	setModalBuyInventoryItem,
	setModalBuyType,
	setModalBuyVisible,
	useLayoutDispatch,
} from '../../redux';
import { calcOldPrice } from '../CaseItem';
import { ShopItem } from '../ShopItem';
import { StyledContainer, StyledEmptyContainer } from './ShopVehicle.styled';

const ShopVehicle = () => {
	const dispatch = useLayoutDispatch();
	const inventoryShopItems = useObservable(rage.donate.getInventoryShopItems());

	const vehicleItems = useMemo(
		() =>
			inventoryShopItems.filter((item) => {
				const rewardType = rage.inventoryDonate.getTypeById(item.donateItemId);
				return rewardType === RewardType.VEHICLE;
			}),
		[inventoryShopItems],
	);

	const isEmpty = vehicleItems.length === 0;

	if (isEmpty) {
		return (
			<StyledEmptyContainer>
				<Text>
					К сожалению,
					<br />
					доступного транспорта нет
				</Text>
			</StyledEmptyContainer>
		);
	}

	return (
		<StyledContainer>
			{vehicleItems.map((item) => {
				const imageId =
					rage.cases.getRewardImageId(item.donateItemId) ?? item.donateItemId;
				const name = rage.cases.getRewardNameById(item.donateItemId);

				return (
					<ShopItem
						type="vehicle"
						id={imageId}
						name={name}
						price={item.price}
						oldPrice={calcOldPrice(item.price, item.discount ?? 0)}
						discount={item.discount ?? undefined}
						dateDiscountEnd={item.discountTimestampEnd ?? undefined}
						dateEnd={item.enabledTimestampEnd ?? undefined}
						key={item.donateItemId}
						onClick={() => {
							dispatch(
								setModalBuyInventoryItem({
									donateItemId: item.donateItemId,
									name,
									price: item.price,
									oldPrice: calcOldPrice(item.price, item.discount ?? 0),
									imageId,
									type: 'vehicle',
									rarity: item.rarity ?? null,
									discount: item.discount ?? null,
									discountTimestampEnd: item.discountTimestampEnd ?? null,
								}),
							);
							dispatch(setModalBuyType('vehicle'));
							dispatch(setModalBuyVisible(true));
						}}
					/>
				);
			})}
		</StyledContainer>
	);
};

export { ShopVehicle };
